export default __webpack_public_path__ + "static/media/light_minting_progress_bg.dc908002.png";